import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { BodyPostHoliday, ResponseGetHoliday } from "./interfaceHoliday";

export const postHoliday = async (body: BodyPostHoliday): Promise<any> => {
    try {
        const data = await postApi('/holiday', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}
export const getHolidayYear = async (yearId?: string): Promise<ResponseGetHoliday[]> => {
    try {
        const data = await getApi(`/holiday?yearId=${yearId}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetHoliday[];
    }
}

export const delteHolidayYear = async (yearId?: number): Promise<any> => {
    try {
        const data = await deleteApi(`/holiday/${yearId}`, yearId);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const patchHoliday = async (body: BodyPostHoliday, idHoladay?: number): Promise<any> => {
    try {
        const data = await patchApi(`/holiday/${idHoladay}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getHolidayId = async (idHoladay?: number): Promise<ResponseGetHoliday> => {
    try {
        const data = await getApi(`/holiday/${idHoladay}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetHoliday;
    }
}